<template>
  <section class="content">
    <admin-header
      :title="'Countries'"
      :uploader="true"
      v-on:open-filter="openFilter"
      v-on:entity-quick-search="search"
      v-on:create-entity-request="goToNewEntityScreen"
      v-on:csv-upload="multiSave"
    ></admin-header>
    <div id="admin-content">
      <router-view></router-view>
    </div>
  </section>
</template>
<script>
  import AdminHeader from '../AdminHeader'
  import AdminScreenMixin from '../../mixins/AdminScreenMixin'
  export default {
    name: 'AdminCountry',
    components: {AdminHeader},
    mixins: [AdminScreenMixin],
    data () {
      return {
        newEntityScreen: 'Admin - Countries',
        searchEntityScreen: 'Admin - Country search',
        filterEventName: 'admin-country-filter',
        filterName: 'CountryFilter',
        entityName: 'country'
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// AdminCountry.vue?731ed3ff